<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-31 16:58:07
 * @FilePath: /wemeet-admin-new/src/components/venueAddUser.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <div class="demo-drawer__footer">
      <el-button type="primary" @click="handleAdd()">添加管理员</el-button>
    </div>
    <el-table border :data="list">
      <el-table-column label="姓名" prop="name" />
      <el-table-column label="操作" show-overflow-tooltip>
        <template #default="{ row }">
          <el-button plain type="danger" @click="handleDel(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-drawer v-model="innerDrawer" :append-to-body="true" :before-close="handleCloseInner" title="添加">
      <el-form ref="formRef" :model="form" :rules="rules">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" type="text" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" type="text" />
        </el-form-item>
      </el-form>
      <el-button style="margin-top: 20px" type="primary" @click="addUser">保存</el-button>
    </el-drawer>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { venueQueryUserList, venueAddUser, venueDelUser } from '@/api/ai'
  export default defineComponent({
    name: 'AddUser',
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        innerDrawer: false,
        direction: 'rtl',
        size: '40%',
        title: '链接地址',
        loading: null,
        form: {},
        registerMobileUrl: [],
        title: '编辑录音',
        total: 0,
        layout: 'total, sizes, prev, pager, next, jumper',
        queryForm: {
          pageSize: 10,
          pageNum: 1,
          scheduleCode: '',
        },
        list: [],
        meetingVenueId: '',
        rules: {
          name: [{ required: true, trigger: 'blur', message: '请输入姓名' }],
          phone: [{ required: true, trigger: 'blur', message: '请输入手机号' }],
        },
        formRef: null,
      })
      // 打开
      const handleOpen = async (row) => {
        state.title = '设置管理员'
        try {
          state.form.meetingVenueId = row.id
          const { data } = await venueQueryUserList({ meetingVenueId: row.id })
          state.list = data
        } catch (e) {
          console.log(e)
        }
        state.dialogFormVisible = true
      }
      // // 关闭
      const handleClose = () => {
        state.form = {
          name: '',
          phone: '',
        }
        state.dialogFormVisible = false
      }

      const handleAdd = () => {
        state.innerDrawer = true
      }

      const addUser = async () => {
        state['formRef'].validate(async (valid) => {
          if (valid) {
            try {
              const { data } = await venueAddUser(state.form)
              proxy.$baseMessage(`添加成功`, 'success', `vab-hey-message-success`)
            } catch (e) {
              proxy.$baseMessage(`添加失败`, 'error', 'vab-hey-message-error')
            }

            state.innerDrawer = false
            state['formRef'].resetFields()
            const { data } = await venueQueryUserList({
              meetingVenueId: state.form.meetingVenueId,
            })
            state.list = data
          }
        })
      }

      const handleDel = async (row) => {
        proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
          await venueDelUser({
            id: row.id,
          })
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          const { data } = await venueQueryUserList({
            meetingVenueId: state.form.meetingVenueId,
          })
          state.list = data
        })
      }

      const handleCloseInner = () => {
        state.form = {
          name: '',
          phone: '',
        }
        state['formRef'].resetFields()
        state.innerDrawer = false
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        handleAdd,
        addUser,
        handleDel,
        handleCloseInner,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .el-descriptions {
    height: 80vh;
    overflow: auto;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    display: flex;
    margin-bottom: 5px;
  }
</style>
